import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useState } from 'react';

export default function Course() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const [showZelleModal, setShowZelleModal] = useState(false);

  return (
    <section id="curso" ref={ref} className="relative py-32 px-6 bg-dark-900">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="order-2 lg:order-1"
          >
            <div className="flex items-center gap-3 mb-6">
              <i className="ri-computer-line text-5xl text-gold-400"></i>
              <h2 className="font-serif text-5xl md:text-6xl text-gold-400">
                El Curso
              </h2>
            </div>

            <h3 className="font-serif text-3xl text-warm-100 mb-8">
              Curso de Cuaresma Completo
            </h3>

            <div className="space-y-6 mb-10">
              <p className="font-sans text-lg text-warm-200 leading-relaxed">
                Una experiencia guiada de 40 días con acompañamiento personalizado, encuentros en vivo y una comunidad que camina contigo.
              </p>

              {/* Pricing */}
              <div className="bg-dark-800 border border-gold-500/30 rounded-lg p-8">
                <div className="space-y-4">
                  <div className="flex items-center justify-between pb-4 border-b border-gold-500/20">
                    <div>
                      <p className="font-sans text-sm text-warm-200 mb-1">Precio especial hasta el 10 de febrero</p>
                      <p className="font-serif text-4xl text-gold-400">$50</p>
                    </div>
                    <div className="bg-gold-500/20 px-4 py-2 rounded-full">
                      <span className="font-sans text-sm text-gold-400 font-semibold">AHORRA $15</span>
                    </div>
                  </div>
                  
                  <div className="flex items-baseline gap-3">
                    <p className="font-sans text-sm text-warm-200">Precio regular después:</p>
                    <p className="font-serif text-2xl text-warm-100">$65</p>
                  </div>
                </div>
              </div>

              {/* Details */}
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <i className="ri-calendar-event-line text-2xl text-gold-400 flex-shrink-0"></i>
                  <div>
                    <p className="font-sans text-warm-100 font-semibold">Inicio: Miércoles de Ceniza</p>
                    <p className="font-sans text-sm text-warm-200">Incluye 1 semana de gabela</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <i className="ri-group-line text-2xl text-gold-400 flex-shrink-0"></i>
                  <p className="font-sans text-warm-200">
                    Acompañamiento diario por WhatsApp y encuentros semanales por Zoom
                  </p>
                </div>

                <div className="flex items-start gap-3">
                  <i className="ri-star-line text-2xl text-gold-400 flex-shrink-0"></i>
                  <p className="font-sans text-warm-200">
                    Semana Santa especial con 7 días de liberaciones interiores
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-4">
              <a
                href="https://www.paypal.me/johannalvarezmusica?locale.x=en_US"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center gap-3 px-10 py-5 bg-gold-500 text-dark-900 font-sans font-semibold text-lg rounded-lg hover:bg-gold-400 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
              >
                <i className="ri-paypal-line text-2xl"></i>
                Inscribirme Ahora
                <i className="ri-arrow-right-line text-xl"></i>
              </a>

              <a
                href="https://square.link/u/FphqtTW2?src=sheet"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center gap-3 px-10 py-5 bg-dark-800 border-2 border-gold-500 text-gold-400 font-sans font-semibold text-lg rounded-lg hover:bg-gold-500/10 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
              >
                <i className="ri-bank-card-2-line text-2xl"></i>
                Pagar con Square
                <i className="ri-arrow-right-line text-xl"></i>
              </a>

              <button
                onClick={() => setShowZelleModal(true)}
                className="inline-flex items-center gap-3 px-10 py-5 bg-dark-800 border-2 border-gold-500 text-gold-400 font-sans font-semibold text-lg rounded-lg hover:bg-gold-500/10 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
              >
                <i className="ri-bank-card-line text-2xl"></i>
                Pagar con Zelle
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative order-1 lg:order-2"
          >
            <div className="relative w-full h-[600px] rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/55de03a58447b22c9804f3000d5f2dfc/30422be74554ff5d9a3a6b0ff623df67.png"
                alt="Curso de Cuaresma"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            </div>
            
            {/* Decorative frame */}
            <div className="absolute -bottom-6 -right-6 w-full h-full border-2 border-gold-500/30 rounded-lg -z-10"></div>
          </motion.div>
        </div>
      </div>

      {/* Zelle Modal */}
      {showZelleModal && (
        <div 
          className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 px-6"
          onClick={() => setShowZelleModal(false)}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="bg-dark-800 border-2 border-gold-500/30 rounded-lg p-8 max-w-md w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between mb-6">
              <h3 className="font-serif text-2xl text-gold-400">Pago con Zelle</h3>
              <button
                onClick={() => setShowZelleModal(false)}
                className="w-10 h-10 flex items-center justify-center text-warm-200 hover:text-gold-400 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-3xl"></i>
              </button>
            </div>

            <div className="bg-white rounded-lg p-6 mb-6">
              <img
                src="https://static.readdy.ai/image/55de03a58447b22c9804f3000d5f2dfc/18989084a2d22874172729e685f56641.png"
                alt="Código QR Zelle"
                className="w-full h-auto"
              />
            </div>

            <div className="text-center space-y-3">
              <p className="font-sans text-warm-100 font-semibold">JOHANN ALVAREZ</p>
              <p className="font-sans text-sm text-warm-200">
                Escanea el código QR con tu app de Zelle para realizar el pago
              </p>
            </div>
          </motion.div>
        </div>
      )}
    </section>
  );
}
